var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5.55556C7 3.03959 9.03959 1 11.5556 1H12.5C14.9853 1 17 3.01472 17 5.5C17 6.05228 16.5523 6.5 16 6.5C15.4477 6.5 15 6.05228 15 5.5C15 4.11929 13.8807 3 12.5 3H11.5556C10.1442 3 9 4.14416 9 5.55556V8.5H17.25C18.7222 8.5 20 9.64849 20 11.1667V16.6667C20 19.1053 17.9387 21 15.5 21H8.5C6.06126 21 4 19.1053 4 16.6667V11.1667C4 9.64849 5.27775 8.5 6.75 8.5H7V5.55556ZM6.75 10.5H8H17.25C17.7108 10.5 18 10.8439 18 11.1667V16.6667C18 17.9099 16.9272 19 15.5 19H8.5C7.07275 19 6 17.9099 6 16.6667V11.1667C6 10.8439 6.28925 10.5 6.75 10.5ZM13 14C13 13.4477 12.5523 13 12 13C11.4477 13 11 13.4477 11 14V16C11 16.5523 11.4477 17 12 17C12.5523 17 13 16.5523 13 16V14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnlocked);
export default __webpack_public_path__ + "static/media/ic_unlocked.d0cb1e3806b6bff25f4d4ac882ef69d9.svg";
export { ForwardRef as ReactComponent };